export default __webpack_public_path__ + "static/media/infraestructura.fb423c92.jpg";